import { useCallback, useEffect, useRef, useState } from 'react';

const getSelectedValueString = (selectedValue) =>
  typeof selectedValue === 'string' ? selectedValue : selectedValue?.address || '';

export const usePlacesAutocompleteField = ({
  selectedValue,
  placesAutocompleteValue,
  setPlacesAutocompleteValue,
  clearSuggestions,
  setOpen,
  setClose
}) => {
  const [value, setValue] = useState(() => {
    const initialSelectedValue = getSelectedValueString(selectedValue);
    return placesAutocompleteValue || initialSelectedValue || '';
  });

  const placesAutocompleteValueRef = useRef(placesAutocompleteValue);
  useEffect(() => {
    placesAutocompleteValueRef.current = placesAutocompleteValue;
  }, [placesAutocompleteValue]);

  useEffect(() => {
    const nextValue = getSelectedValueString(selectedValue);
    setValue(nextValue);
    if (placesAutocompleteValueRef.current !== nextValue) {
      setPlacesAutocompleteValue(nextValue, false);
    }
    clearSuggestions();
    setClose();
  }, [selectedValue, clearSuggestions, setClose, setPlacesAutocompleteValue]);

  const onChangeValue = useCallback(
    (newValue, placesAutocompleteParam = undefined) => {
      setValue(newValue);
      setPlacesAutocompleteValue(newValue, placesAutocompleteParam);
      if (!newValue) {
        clearSuggestions();
        setClose();
        return;
      }
      setOpen();
    },
    [clearSuggestions, setClose, setOpen, setPlacesAutocompleteValue]
  );

  return { value, onChangeValue };
};
